import React from 'react';
import ResultComingSoon from 'components/common/ResultComingSoon';
import i18next from 'i18next';

const VisitsTours = () => (
  <ResultComingSoon description={i18next.t('sideBar.visits&tours')} />
);

export default VisitsTours;
